// Formatting + date helpers
export const fmtCurrency = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(
    Number(n || 0)
  );

export const fmtCurrencyCents = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(
    Number(n || 0)
  );

export const fmtNumber = (n) => new Intl.NumberFormat("en-US").format(Number(n || 0));

export const fmtDate = (iso) => {
  if (!iso) return "\u2014";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const fmtDateTime = (iso) => {
  if (!iso) return "\u2014";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

const toYMD = (d) => d.toISOString().slice(0, 10);

export const DATE_PRESETS = [
  { key: "7d", label: "7 days" },
  { key: "30d", label: "30 days" },
  { key: "90d", label: "90 days" },
  { key: "ytd", label: "YTD" },
  { key: "all", label: "All" },
];

export function presetToRange(key) {
  const end = new Date();
  let start = null;
  if (key === "7d") start = new Date(Date.now() - 7 * 864e5);
  else if (key === "30d") start = new Date(Date.now() - 30 * 864e5);
  else if (key === "90d") start = new Date(Date.now() - 90 * 864e5);
  else if (key === "ytd") start = new Date(new Date().getFullYear(), 0, 1);
  else if (key === "all") start = null;
  return {
    start_date: start ? toYMD(start) : "",
    end_date: key === "all" ? "" : toYMD(end),
  };
}

export const STATUS_LABELS = {
  booked: "Booked",
  seated: "Seated",
  completed: "Completed",
  cancelled: "Cancelled",
  no_show: "No-show",
  new: "New",
  contacted: "Contacted",
  confirmed: "Confirmed",
  lost: "Lost",
};
